import { ExpressionRuleEditor } from "../ExpressionRuleEditor";
import { GroupedBracketedDiv } from "../Logic/AndGroupEditor";
import { BracketedDiv, ExpressionPiece } from "../../Builder/ExpressionStyles";
import { ExpressionValueRenderer } from "../../Builder/ExpressionValueRenderer";
import { ExpressionValueType } from "../../../rule-engine-core/Expressions/ExpressionValueType";
import React from "react";
import { StringListInExpression } from "../../../rule-engine-core/Expressions/Expressions/String/StringListInExpression";

export class StringListInExpressionEditor extends ExpressionRuleEditor<StringListInExpression> {
    render() {
        return (
            <GroupedBracketedDiv issue={this.ruleData!.getValidationIssues()[0]}>
                <ExpressionPiece>
                    <ExpressionValueRenderer el={this.ruleData!.value1!} />
                </ExpressionPiece>
                <ExpressionPiece> in </ExpressionPiece>
                {this.ruleData!.value2!.valueType === ExpressionValueType.VALUE ? (
                    <BracketedDiv>
                        <ExpressionValueRenderer el={this.ruleData!.value2!} />
                    </BracketedDiv>
                ) : (
                    <ExpressionPiece>
                        <ExpressionValueRenderer el={this.ruleData!.value2!} />
                    </ExpressionPiece>
                )}
            </GroupedBracketedDiv>
        );
    }
}
